import { EventEmitter, Injectable } from '@angular/core';
import { FhSideBarHeaderConfigModel } from '../objects/fh-side-bar-header-config/fh-side-bar-header-config-model';
import { FhSideBarVisibleEmitterModel } from '../objects/fh-side-bar-visible-emitter/fh-side-bar-visible-emitter-model';

@Injectable({
  providedIn: 'root'
})
export class FhSideBarProviderService {
  visibleChangedEmitter: EventEmitter<FhSideBarVisibleEmitterModel> = new EventEmitter<FhSideBarVisibleEmitterModel>();
  widthChangedEmitter: EventEmitter<string> = new EventEmitter<string>();
  configHeaderEmitter: EventEmitter<FhSideBarHeaderConfigModel> = new EventEmitter<FhSideBarHeaderConfigModel>();
  navigateBackHeaderEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}
}
